<template>
	<div class="app-accordion" :class="{ opened }" ref="AppAccordCont">
		<div class="app-accordion-header" @click="toggle">
			<div class="app-accordion-header-content">
				<slot name="header"></slot>
			</div>
			<app-icon v-if="!hideCaret" class="app-accordion-header-icon" icon="right" />
		</div>
		<div class="app-accordion-content-container">
			<slot />
		</div>
	</div>
</template>

<script>
	import AppIcon from './AppIcon';

	export default {
		name: 'AppAccordion',
		components: {
			AppIcon,
		},
		emits: ['onOpen', 'onClose'],
		props: {
			isOpened: {
				required: false,
				default: false,
			},
			hideCaret: {
				required: false,
				default: false,
			},
			isSidebarOpen: {
				required: false,
				default: false,
			},
		},
		data() {
			return {
				opened: false,
			};
		},
		methods: {
			toggle() {
				this.opened = !this.opened;
				this.$nextTick(() => {
					this.$refs.AppAccordCont.scrollIntoView(true);
				});
				if (this.opened) {
					this.$emit('onOpen');
				} else {
					this.$emit('onClose');
				}
			},
		},
		mounted() {
			this.opened = this.isOpened;
		},
		watch: {
			isSidebarOpen(val) {
				this.opened = !!val && this.isOpened;
			},
		},
	};
</script>
